import React, { FC } from "react";
import styled from "@emotion/styled";
import ASelect, { SelectProps, OptionType } from "@atlaskit/select";
import { HelpTooltip } from "../../components/HelpTooltip";
import { InputLabel } from "../InputLabel";
import { Box } from "../Box";

interface IProps extends SelectProps<OptionType, false> {
  label?: string;
  name?: string;
  fullWidth?: boolean;
  labelHelpTooltop?: string;
}

const StyledHelpTooltip = styled(HelpTooltip)`
  width: 15px;
  height: 15px;
`;

export const Select: FC<IProps> = ({ label, labelHelpTooltop, fullWidth, ...props }) => (
  <Box width={fullWidth ? "100%" : 200}>
    {label && labelHelpTooltop && (
      <StyledHelpTooltip title={label} text={labelHelpTooltop}>
        <InputLabel htmlFor={props.inputId}>{label}</InputLabel>
      </StyledHelpTooltip>
    )}
    {label && !labelHelpTooltop && <InputLabel htmlFor={props.inputId}>{label}</InputLabel>}
    <ASelect {...props} />
  </Box>
);
